const checkInlineValidation = (currentData, prevData) => {
  return currentData?.accountId !== prevData?.name || currentData?.platform?.value !== prevData?.platform;
};

export default checkInlineValidation;
